import { Route } from 'vue-router'

//  Helper methods
const getDeepLinkParams = (to: Route) => {
    //  Stores the route to navigate to
    var deepLink = null

    //  The params to append to the redirected url (i.e. /signin)
    var params = null

    //  A list of valid paths to navigate to
    const validPaths = ['/inbox/', '/billing/manage/', '/billing/subscription/', '/billing/plan/', '/brand-info/', '/teammates/']

    //  Check if the route being navigated to is valid
    const valid = validPaths.includes(to.path.slice(-1) == '/' ? to.path : to.path + '/') && !to.fullPath.includes('goto')

    //  If valid, set the deepLink to the fullPath (this includes other query params)
    if (valid) deepLink = { goto: to.fullPath }

    // If the deepLink is valid, add the full url to the query params
    if (deepLink) params = `?${window.toUrlParams(deepLink)}`
    //  URL Format the query params
    else params = to.query ? `?${window.toUrlParams(deepLink)}` : ''

    //  Return the params
    return params
}

export { getDeepLinkParams }